import {create} from 'zustand';
import type {ProjectInfo, MemberRoleItem} from '@/types/project';
import type {ProjectId} from '@/types';

interface ProjectStore {
    /** 当前选中的项目 ID */
    currentProjectId: ProjectId | null;
    /** 当前项目基本信息 */
    projectInfo: ProjectInfo | null;
    /** 成员角色列表（来自 /member/list） */
    roleList: MemberRoleItem[];
    /** 设置当前项目 ID */
    setCurrentProjectId: (id: ProjectId) => void;
    /** 设置当前项目信息 */
    setProjectInfo: (info: ProjectInfo) => void;
    /** 设置成员角色列表 */
    setRoleList: (list: MemberRoleItem[]) => void;
    /** 清除当前项目数据（切换项目时调用） */
    clearProject: () => void;
}

export const useProjectStore = create<ProjectStore>((set) => ({
    currentProjectId: null,
    projectInfo: null,
    roleList: [],
    setCurrentProjectId: (id: ProjectId) => set({currentProjectId: id}),
    setProjectInfo: (info: ProjectInfo) => set({projectInfo: info}),
    setRoleList: (list: MemberRoleItem[]) => set({roleList: list}),
    clearProject: () => set({currentProjectId: null, projectInfo: null}),
}));
